import { Component, Input, OnInit } from '@angular/core';
import { LegFiJwtService } from 'app/services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from 'app/services/auth/jwt-legfi-claims.model';
import { FilterContainerComponent } from '../filter-container/filter-container.component';

@Component({
    selector: 'report-filter-unit-selection',
    templateUrl: './unit-selection-filter.component.html',
    styleUrls: ['./unit-selection-filter.component.scss'],
})
export class UnitSelectionFilterComponent implements OnInit
{
    jwt: JwtLegFiClaims;

    expanded: boolean = false;

    @Input()
    public container: FilterContainerComponent;

    @Input()
    public filters: { unitIds: number[] } = null;

    constructor() {
    }

    ngOnInit() {
        this.container.register(this);
        this.jwt = LegFiJwtService.read();
        this.filters = {
            unitIds: [],
        };
        this.container.notifyReady(this);
    }

    updateModel(units) {
        this.filters.unitIds = units.map(unit => {
            return unit.id;
        });
    }
}
